import { Validator } from 'vee-validate';
import isEmail from 'validator/lib/isEmail';
import i18n from '@/locales';

const containsRegex = {
  getMessage(field, [regexString, countString = '1']) {
    const count = parseInt(countString, 10);

    return i18n.tc('error.containsRegex', count, {
      field, regexString, count: countString,
    });
  },
  validate(value, [regexString, countString = '1']) {
    const count = parseInt(countString, 10);
    const regex = new RegExp(regexString);

    const match = value.match(regex);

    return !!match && match.length >= count;
  },
};

const passwordGeneral = {
  getMessage(field) {
    return i18n.tc('error.passwordErrorGeneral', {
      field,
    });
  },
  validate(value) {
    return !!value.match(new RegExp('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).*$'));
    },
};

const containsLowerCaseLetters = {
  getMessage(field, [countString = '1']) {
    const count = parseInt(countString, 10);

    return i18n.tc('error.containsLowerCaseLetters', count, {
      field, count: countString,
    });
  },
  validate(value, [countString = '1']) {
    const count = parseInt(countString, 10);

    return containsRegex.validate(value, ['[a-z]', count]);
  },
};

const containsUpperCaseLetters = {
  getMessage(field, [countString = '1']) {
    const count = parseInt(countString, 10);

    return i18n.tc('error.containsUpperCaseLetters', count, {
      field, count: countString,
    });
  },
  validate(value, [countString = '1']) {
    const count = parseInt(countString, 10);

    return containsRegex.validate(value, ['[A-Z]', count]);
  },
};

const containsNumbers = {
  getMessage(field, [countString = '1']) {
    const count = parseInt(countString, 10);

    return i18n.tc('error.containsNumbers', count, {
      field, count: countString,
    });
  },
  validate(value, [countString = '1']) {
    const count = parseInt(countString, 10);

    return containsRegex.validate(value, ['\\d', count]);
  },
};

const isSortcode = {
  getMessage() {
    return i18n.t('error.invalidSort');
  },
  validate(value) {
    const regex = /^(\d){2}-(\d){2}-(\d){2}$/i;
    const match = value.match(regex);

    return !!match && value.length === 8;
  },
};

const isUKBAN = {
  getMessage() {
    return i18n.t('error.invalidUKBAN');
  },
  validate(value) {
    let string = value;
    if (value.length === 7) string = `0${value}`;

    const regex = /^(\d){8}$/i;
    const match = string.match(regex);

    return !!match;
  },
};

const hexcode = {
  getMessage: field => i18n.tc('error.invalidhexcode', field, {
    field,
  }),
  validate: (value) => {
    const conditions = /^#([0-9a-fA-F]{2}){3}$/g;
    return conditions.test(value);
  },
};

const isPhoneNumber = {
  getMessage: field => i18n.tc('error.invalidPhoneNumber', field, { field }),
  validate: value => /^[0-9\-+ ]+$/.test(value.trim()),
};

const isTrimmedEmail = {
    getMessage: field => i18n.tc('error.invalidEmail', field, { field }),
    validate: value => isEmail(String(value).trim()),
};

export default () => {
  Validator.extend('containsRegex', containsRegex);
  Validator.extend('passwordGeneral', passwordGeneral);
  Validator.extend('containsLowerCaseLetters', containsLowerCaseLetters);
  Validator.extend('containsUpperCaseLetters', containsUpperCaseLetters);
  Validator.extend('containsNumbers', containsNumbers);
  Validator.extend('isSortcode', isSortcode);
  Validator.extend('isUKBAN', isUKBAN);
  Validator.extend('isUKBAN', isUKBAN);
  Validator.extend('hexcode', hexcode);
  Validator.extend('isPhoneNumber', isPhoneNumber);
  Validator.extend('isTrimmedEmail', isTrimmedEmail);
};
